var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8077 17.4998C2.30898 17.4998 1.88302 17.3232 1.52982 16.97C1.17661 16.6168 1 16.1908 1 15.6921V2.99981H0V1.49983H4.49997V0.615234H10.5V1.49983H15V2.99981H14V15.6921C14 16.1972 13.825 16.6248 13.475 16.9748C13.125 17.3248 12.6974 17.4998 12.1922 17.4998H2.8077ZM12.5 2.99981H2.49997V15.6921C2.49997 15.7818 2.52883 15.8556 2.58652 15.9133C2.64422 15.971 2.71795 15.9998 2.8077 15.9998H12.1922C12.2692 15.9998 12.3397 15.9678 12.4038 15.9037C12.4679 15.8395 12.5 15.769 12.5 15.6921V2.99981ZM4.90385 13.9998H6.40382V4.99981H4.90385V13.9998ZM8.59613 13.9998H10.0961V4.99981H8.59613V13.9998Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.0d464de6d6b47e4097baf2a75df5e3c3.svg";
export { ForwardRef as ReactComponent };